import { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { openLoginModal } from "../../redux/reducer/modal.reducer";

export default function useRequireAuth() {
  const dispatch = useDispatch();
  const { token } = useSelector((state) => state.common);
  const isAuthenticated = Boolean(token || localStorage.getItem("token"));

  const requireAuth = useCallback(
    (onAuthenticated, pendingAction = null) => {
      if (!isAuthenticated) {
        dispatch(openLoginModal(pendingAction));
        return false;
      }

      onAuthenticated?.();
      return true;
    },
    [dispatch, isAuthenticated],
  );

  return { isAuthenticated, requireAuth };
}
